module.exports = __webpack_public_path__ + "img/H-45-ST-1000-BB.86988297.png";